import { Component, ElementRef, EventEmitter, HostListener, Injectable, Input, Output, ViewChild } from '@angular/core';
import { UserDetailsService } from '../services/user-details.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPencil, faEnvelope, faEnvelopeOpen, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ApiServicesService } from '../services/api-services.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SnackbarService } from '../services/snackbar.service';
import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-message-listing',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule, FontAwesomeModule, MatCheckboxModule, RouterLink],
  templateUrl: './message-listing.component.html',
  styleUrl: './message-listing.component.css',
  exportAs: 'messageListing'
})
export class MessageListingComponent {
  @Input() del!: boolean;
  userData: any;
  profilePic: any;
  userName: any;
  Message = faEnvelope;
  MessageOpen = faEnvelopeOpen;
  @Input() inbox!: boolean;
  @Input() draft!: boolean;
  @Input() send!: boolean;
  

  DraftMsg!: any;
  back = faArrowLeft;
  pencile = faPencil;
  userId: any;
  page = 1;
  limit = 10;
  MsgResponce: any;
  shimmer = true;
  isLoading: any;
  totalPages: any;
  conversation: any;
  @Output() go_inside: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() conversationID = new EventEmitter<{ ID: any; is_delete: any }>();
  @Output() draftConId = new EventEmitter<{ id: number; userId: string; body: any; subject: any; conversationId: any; username: any }>();
  conversationId: any;
  selectedMsg: string[] = [];
  isload = false;
  is_delete = true;
  isProcessing: any;

  constructor(
    private userdetails: UserDetailsService, private apiservices: ApiServicesService, private snackbarService: SnackbarService
  ) { }
  ngOnInit() {
    this.is_delete = false;
    this.userdetails.userdetails$.subscribe((userData) => {
      this.userData = userData;
      if (userData && userData.user) {
        this.profilePic = userData?.thumbnail_image || '';
        this.userName = userData?.user?.username;
        this.userId = this.userData.user._id;
      }
    });



    if (this.del == true) {
      this.MsgResponce = [];
      this.getDeleted()
      this.is_delete = true;
    }

    if (this.draft == true) {
      this.MsgResponce = [];
      this.getdraft()
    }

    if (this.inbox == true) {
      this.MsgResponce = [];
      this.getInbox();
    }


    if (this.send == true) {
      this.MsgResponce = [];
      this.getSend()
    }
  }



  isTruncated: boolean = true;
  showToggleButton: boolean = false;


  get toggleButtonText(): string {
    return this.isTruncated ? '...more' : '...hide';
  }

  toggledIndex: number | null = null; // Tracks which message is toggled (null means none)

  toggleText(index: number): void {
    this.toggledIndex = this.toggledIndex === index ? null : index; // Toggle the clicked message
  }


  inbox_inside(ID: any) {
    this.conversationID.emit({ ID: ID, is_delete: this.is_delete });
  }




  editMsg(Id: any, userId: any, body: any, subject: any, conversation: any, username: any) {
    this.draftConId.emit({ id: Id, userId: userId, body: body, subject: subject, conversationId: conversation, username: username });

  }



  deleteConMsg() {
    this.apiservices.deleteConMsg(this.selectedMsg).subscribe({
      next: (responce: any) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: 'Message deleted successfully',
            className: 'success',
          }
        );
      },
      error: (err) => {
      }
    });

  }


  onCheckboxChange(value: string, isChecked: boolean): void {

    if (isChecked) {
      // Add the value to the array if checked
      if (!this.selectedMsg.includes(value)) {
        this.selectedMsg.push(value);
      }
    } else {
      // Remove the value from the array if unchecked
      const index = this.selectedMsg.indexOf(value);
      if (index > -1) {
        this.selectedMsg.splice(index, 1);
      }
    }

  }

  deleteMsg() {
    if (this.isProcessing) {
      return; // Exit if a request is already in progress
    }

    this.isProcessing = true; // Set the flag to true
    this.isload = true;
    this.page = 1;

    if (this.inbox) {
      this.apiservices.deleteConMsg(this.selectedMsg).subscribe({
        next: (response: any) => {
          this.isProcessing = false; // Reset the flag
          this.isload = false;
          this.page = 1;
          this.getInbox();
          this.selectedMsg=[];
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'Message deleted successfully',
            className: 'success',
          });
        },
        error: () => {
          this.isProcessing = false; // Reset the flag on error
          this.isload = false;
        }
      });

    }else if(this.is_delete){
      this.apiservices.deleteDelMsg(this.selectedMsg).subscribe({
        next: (response: any) => {
          this.isProcessing = false; // Reset the flag
          this.isload = false;
          this.selectedMsg=[];

          this.getDeleted();
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'Message deleted successfully',
            className: 'success',
          });
        },
        error: () => {
          this.isProcessing = false; // Reset the flag on error
          this.isload = false;
        }
      });


    }else if (this.draft) {
      this.apiservices.deleteDraftMsg(this.selectedMsg).subscribe({
        next: (response: any) => {
          this.isProcessing = false; // Reset the flag
          this.isload = false;

          this.getdraft();
          this.selectedMsg=[];
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'Message deleted successfully',
            className: 'success',
          });
        },
        error: () => {
          this.isProcessing = false; // Reset the flag on error
          this.isload = false;
        }
      });

    } else {
      this.apiservices.deleteSendMsg(this.selectedMsg).subscribe({
        next: (response: any) => {
          this.isProcessing = false; // Reset the flag
          this.isload = false;
          this.getSend();
          this.selectedMsg=[];

          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'Message deleted successfully',
            className: 'success',
          });
        },
        error: () => {
          this.isProcessing = false; // Reset the flag on error
          this.isload = false;
        }
      });
    }
  }



  getDeleted() {
    this.apiservices.getDeleted(this.page, this.limit).subscribe({
      next: (responce: any) => {
        if (this.page == 1) {
          this.MsgResponce = responce.data;
        } else {
          this.MsgResponce = [...this.MsgResponce, ...responce.data]
        }

        this.shimmer = false;
        this.totalPages = responce.pagination.totalPages;

        if(responce.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );
        }

        
      },
      error: (err) => {
        this.shimmer = false;
        this.MsgResponce = [];
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );

      }
    });
  }


  getdraft() {
    this.apiservices.getDraftMsg(this.page, this.limit).subscribe({
      next: (responce: any) => {
        if (this.page == 1) {
          this.MsgResponce = responce.data;
        } else {
          this.MsgResponce = [...this.MsgResponce, ...responce.data]
        }
        this.shimmer = false;
        this.totalPages = responce.pagination.totalPages;

        if(responce.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );
        }


      },
      error: (err) => {
        this.shimmer = false;
        this.MsgResponce = [];
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  getInbox() {
    this.apiservices.getInboxMsg(this.page, this.limit).subscribe({
      next: (responce: any) => {
        if (this.page == 1) {
          this.MsgResponce = responce?.data;
        } else {
          this.MsgResponce = [...this.MsgResponce, ...responce?.data]
        }
        this.shimmer = false;
        this.totalPages = responce?.pagination?.totalPages;

        if(responce.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );
        }
        

      },
      error: (err) => {
        this.shimmer = false;
        this.MsgResponce = [];
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  getSend() {
    this.apiservices.getSendMsg(this.page, this.limit).subscribe({
      next: (responce: any) => {
        if (this.page == 1) {
          this.MsgResponce = responce.messages;
        } else {
          this.MsgResponce = [...this.MsgResponce, ...responce.messages]
        }

        this.totalPages = responce?.pagination?.totalPages;
        this.shimmer = false;

        if(responce.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );
        }


      },
      error: (err) => {
        this.shimmer = false;
        this.MsgResponce = [];
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
  @HostListener('window:scroll', ["$event"])
  onScroll(event: Event): void {
    if (!this.scrollContainer) return;
    const target = this.scrollContainer.nativeElement as HTMLElement;
    const rect = target.getBoundingClientRect(); // Get element position relative to the viewport
    const windowHeight = window.innerHeight;
    if (
      rect.bottom <= windowHeight + 100 && !this.shimmer && this.MsgResponce && (this.page < this.totalPages)) {
      this.shimmer = true;
      if (this.draft) {
        this.page++;
        this.getdraft()

      } else if (this.inbox) {
        this.page++;
        this.getInbox();
      }
      else if (this.del) {
        this.page++;
        this.getDeleted();
      }
      else if (this.send) {
        this.page++;
        this.getSend();
      }
    }
  }

}
